import React from 'react'
import { RatingTooltipStyles, TooltipRatingLabelStyles } from './Style'
import { ratingColors, ratingListLabel } from 'keys/rating'
import { Tooltip } from 'components/Form'
import { maxWidth, minWidth } from '@mui/system'

const RatingTooltip = (props) => {
    const { selectedIndex, rating = ratingListLabel } = props

    return (
        <RatingTooltipStyles>
            <Tooltip
                placement={"left"}
                slotProps={{
                    tooltip: {
                        sx: {
                            whiteSpace: 'nowrap',
                            color: "#26445A80",
                            backgroundColor: "#ffff",
                            borderRadius: 2,
                            maxWidth: 400,
                        },
                    },
                }}
                title={
                    <div style={{ display: "flex", columnGap: 5, padding: 6 }}>
                        {rating.map((label, index) =>
                            <TooltipRatingLabelStyles selected={index + 1 == selectedIndex} color={index + 1 == selectedIndex && ratingColors[index]}>
                                {label}
                                {index != ratingListLabel.length - 1 && ','}
                            </TooltipRatingLabelStyles>
                        )}
                    </div>
                }
            />
        </RatingTooltipStyles>
    )
}

export default RatingTooltip